import React, { useState } from 'react';
import { debounce } from '../lib/Utils.js';
import mailcheck from 'mailcheck';
import InputContainer from '~/components/InputContainer';

const debouncedMailcheck = debounce(function (value, setSuggestion) {
    mailcheck.run({
        email: value,
        suggested: result => {
            if (
                result.domain.length > 2 &&
                result.domain.indexOf('.') > -1 &&
                result
            ) {
                setSuggestion(result);
            } else {
                setSuggestion(null);
            }
        },
        empty: () => {
            setSuggestion(null);
        },
    });
}, 300);

const EmailInput = ({
    value,
    onChange,
    className,
    label,
    id,
    allowMultiple,
    error,
    ...props
}) => {
    const [suggestion, setSuggestion] = useState(null);

    function doOnChange(newValue) {
        onChange(newValue);

        // Check for typos...
        debouncedMailcheck(newValue, setSuggestion);
    }

    return (
        <InputContainer
            className={className}
            label={label}
            id={id}
            error={error}
        >
            <input
                type={allowMultiple ? 'text' : 'email'}
                value={value || ''}
                onChange={e => doOnChange(e.target.value)}
                {...props}
            />
            {!!suggestion && (
                <div className="ml-2 text-sm flex items-center">
                    Did you mean
                    <a
                        href="#"
                        onClick={ev => {
                            ev.preventDefault();
                            doOnChange(suggestion.full);
                        }}
                        className="black-clickable underline pl-1"
                    >
                        {suggestion.address}@
                        <span className="italic">{suggestion.domain}</span>
                    </a>
                    ?
                </div>
            )}
        </InputContainer>
    );
};

export default EmailInput;
